import { createSlice } from '@reduxjs/toolkit'
import { strapiFetch, StrapiApiError } from '../../api/strapi'

const slice = createSlice({
    name: 'global',
    initialState: {
        data: null,
        loading: false,
        loaded: false,
        error: null,
    },
    reducers: {
        setLoading: (state, action) => { state.loading = action.payload },
        setLoaded: (state, action) => { state.loaded = action.payload },
        setData: (state, action) => { state.data = action.payload },
        setError: (state, action) => { state.error = action.payload },
    },
})

export default slice.reducer

const { setLoading, setLoaded, setData, setError } = slice.actions

// Global Settings (header/footer/social links) + Glossary Entries — chrome
// that's shared across every page, so this is dispatched once at App level
// rather than per-page like the other domain slices.
export const loadGlobalData = (locale) => async dispatch => {
    dispatch(setLoading(true))
    dispatch(setError(null))
    try {
        const [settings, glossaryEntries] = await Promise.all([
            strapiFetch('/api/global-setting', { locale, params: { populate: '*' } }),
            strapiFetch('/api/glossary-entries', { locale, params: { 'pagination[pageSize]': 200 } }),
        ])
        const glossary = {}
        glossaryEntries.data.forEach(entry => {
            glossary[entry.key] = entry.word
        })
        dispatch(setData({ settings: settings.data, glossary }))
        dispatch(setLoaded(true))
    } catch (e) {
        dispatch(setError(e instanceof StrapiApiError ? e.message : 'Failed to load global settings'))
    } finally {
        dispatch(setLoading(false))
    }
}
